import { render, staticRenderFns } from "./EmergingArtists.vue?vue&type=template&id=061ae9a1&"
import script from "./EmergingArtists.vue?vue&type=script&lang=js&"
export * from "./EmergingArtists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports